import React, { Component } from 'react';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class SoonoToaster extends Component {
  render() {
    const autoCloseTime = 3000;
    return (
      <ToastContainer
        position="top-right"
        transition={Zoom}
        autoClose={autoCloseTime}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnVisibilityChange={false}
        draggable
        pauseOnHover />
    )
  }
}

export default SoonoToaster;



// WEBPACK FOOTER //
// ./src/utils/SoonoToaster.js